import List from './TabList';
import Panel from './TabPanel';
import Panels from './TabPanels';
import Tab from './TabTab';

export default { List, Tab, Panels, Panel };
